import { render, staticRenderFns } from "./AcessarAtaControleSaldosOrgaoView.vue?vue&type=template&id=39adac80"
import script from "./AcessarAtaControleSaldosOrgaoView.vue?vue&type=script&lang=js"
export * from "./AcessarAtaControleSaldosOrgaoView.vue?vue&type=script&lang=js"
import style0 from "./AcessarAtaControleSaldosOrgaoView.vue?vue&type=style&index=0&id=39adac80&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports